module.exports = __webpack_public_path__ + "img/integrations-squarespace.173b7c56.png";